module.exports = __webpack_public_path__ + "static/media/people-keep-benefits-personalized.65e545b1.svg";